import { Languages } from "@/constants/languages";
// Female Lose Weight In Weeks Charts
import goalInWeeksLoseWeightDe from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-lw/goalInWeeksLoseWeight-de.svg";
import goalInWeeksLoseWeightEn from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-lw/goalInWeeksLoseWeight-en.svg";
import goalInWeeksLoseWeightEs from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-lw/goalInWeeksLoseWeight-es.svg";
import goalInWeeksLoseWeightFr from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-lw/goalInWeeksLoseWeight-fr.svg";
import goalInWeeksLoseWeightPt from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-lw/goalInWeeksLoseWeight-pt.svg";
// Female Muscle Gain In Weeks Charts
import goalInWeeksMuscleGainDe from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-mg/goalInWeeksMuscleGain-de.svg";
import goalInWeeksMuscleGainEn from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-mg/goalInWeeksMuscleGain-en.svg";
import goalInWeeksMuscleGainEs from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-mg/goalInWeeksMuscleGain-es.svg";
import goalInWeeksMuscleGainFr from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-mg/goalInWeeksMuscleGain-fr.svg";
import goalInWeeksMuscleGainPt from "@/female/assets/funnel-upgrade-female/charts/goal-in-weeks-mg/goalInWeeksMuscleGain-pt.svg";
// Female Your Progress with Zing AI Charts
import yourProgressWithZingAIChartDe from "@/female/assets/funnel-upgrade-female/charts/your-progress-with-zing-ai/yourProgressWithZingAI-de.svg";
import yourProgressWithZingAIChartEn from "@/female/assets/funnel-upgrade-female/charts/your-progress-with-zing-ai/yourProgressWithZingAI-en.svg";
import yourProgressWithZingAIChartEs from "@/female/assets/funnel-upgrade-female/charts/your-progress-with-zing-ai/yourProgressWithZingAI-es.svg";
import yourProgressWithZingAIChartFr from "@/female/assets/funnel-upgrade-female/charts/your-progress-with-zing-ai/yourProgressWithZingAI-fr.svg";
import yourProgressWithZingAIChartPt from "@/female/assets/funnel-upgrade-female/charts/your-progress-with-zing-ai/yourProgressWithZingAI-pt.svg";
// Female Device Images
import deviceImgDe from "@/female/assets/funnel-upgrade-female/motivational/device/device-de.svg";
import deviceImgEn from "@/female/assets/funnel-upgrade-female/motivational/device/device-en.svg";
import deviceImgEs from "@/female/assets/funnel-upgrade-female/motivational/device/device-es.svg";
import deviceImgFr from "@/female/assets/funnel-upgrade-female/motivational/device/device-fr.svg";
import deviceImgPt from "@/female/assets/funnel-upgrade-female/motivational/device/device-pt.svg";
// Female Plan For You Images
import planForYouImgDe from "@/female/assets/funnel-upgrade-female/motivational/plan-for-you/planForYou-de.webp";
import planForYouImgEn from "@/female/assets/funnel-upgrade-female/motivational/plan-for-you/planForYou-en.webp";
import planForYouImgEs from "@/female/assets/funnel-upgrade-female/motivational/plan-for-you/planForYou-es.webp";
import planForYouImgFr from "@/female/assets/funnel-upgrade-female/motivational/plan-for-you/planForYou-fr.webp";
import planForYouImgPt from "@/female/assets/funnel-upgrade-female/motivational/plan-for-you/planForYou-pt.webp";
// Female Weekly Energy Level Images
import weeklyEnergyLevelImgDe from "@/female/assets/funnel-upgrade-female/motivational/weekly-energy-level/weeklyEnergyLevel-de.svg";
import weeklyEnergyLevelImgEn from "@/female/assets/funnel-upgrade-female/motivational/weekly-energy-level/weeklyEnergyLevel-en.svg";
import weeklyEnergyLevelImgEs from "@/female/assets/funnel-upgrade-female/motivational/weekly-energy-level/weeklyEnergyLevel-es.svg";
import weeklyEnergyLevelImgFr from "@/female/assets/funnel-upgrade-female/motivational/weekly-energy-level/weeklyEnergyLevel-fr.svg";
import weeklyEnergyLevelImgPt from "@/female/assets/funnel-upgrade-female/motivational/weekly-energy-level/weeklyEnergyLevel-pt.svg";

export const mapYourProgressWithZingAIChartByLng = {
    [Languages.Spanish]: yourProgressWithZingAIChartEs,
    [Languages.English]: yourProgressWithZingAIChartEn,
    [Languages.German]: yourProgressWithZingAIChartDe,
    [Languages.Portuguese]: yourProgressWithZingAIChartPt,
    [Languages.French]: yourProgressWithZingAIChartFr,
};

export const mapGoalInWeeksLoseWeightChartByLng = {
    [Languages.Spanish]: goalInWeeksLoseWeightEs,
    [Languages.English]: goalInWeeksLoseWeightEn,
    [Languages.German]: goalInWeeksLoseWeightDe,
    [Languages.Portuguese]: goalInWeeksLoseWeightPt,
    [Languages.French]: goalInWeeksLoseWeightFr,
};

export const mapGoalInWeeksMuscleGainChartByLng = {
    [Languages.Spanish]: goalInWeeksMuscleGainEs,
    [Languages.English]: goalInWeeksMuscleGainEn,
    [Languages.German]: goalInWeeksMuscleGainDe,
    [Languages.Portuguese]: goalInWeeksMuscleGainPt,
    [Languages.French]: goalInWeeksMuscleGainFr,
};

export const mapDeviceImgByLng = {
    [Languages.Spanish]: deviceImgEs,
    [Languages.English]: deviceImgEn,
    [Languages.German]: deviceImgDe,
    [Languages.Portuguese]: deviceImgPt,
    [Languages.French]: deviceImgFr,
};

export const mapPlanForYouImgByLng = {
    [Languages.Spanish]: planForYouImgEs,
    [Languages.English]: planForYouImgEn,
    [Languages.German]: planForYouImgDe,
    [Languages.Portuguese]: planForYouImgPt,
    [Languages.French]: planForYouImgFr,
};

export const mapWeeklyEnergyLevelImgByLng = {
    [Languages.Spanish]: weeklyEnergyLevelImgEs,
    [Languages.English]: weeklyEnergyLevelImgEn,
    [Languages.German]: weeklyEnergyLevelImgDe,
    [Languages.Portuguese]: weeklyEnergyLevelImgPt,
    [Languages.French]: weeklyEnergyLevelImgFr,
};
